//accordions to display item details in bulk approval dialogf
import { Accordion, AccordionDetails, AccordionSummary } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { DetailsDisplay, ViewImage, useAuthInfo } from "../../common";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";

export default function BulkApprovalAccordion({ rowData, index }) {
  const gridProperties = { xs: 12, sm: 12, mt: 2 };
  // Fetching user authentication information using custom hook
  let decoded = useAuthInfo();

  //destructure data
  const {
    id,
    qualityReportsID,
    sampleRequestID,
    sampleItemID,
    HODApproval,
    execChefApproval,
    userApproval,
    itemERPCode,
    itemDescription,
    specification,
    productClass,
    requesterEmail,
    executiveChefEmail,
    HODDepartment,
    primaryProductImages,
    secondaryProductImages,
    productImages,
    requestDate,
    email,
    name,
    erpId,
    erpName,
    ...rowRest
  } = rowData;

  //identifiers group
  const ids = {
    requestDate,
    qualityReportsID,
    sampleItemID,
    sampleRequestID,
  };

  // item details group
  const itemDetails = {
    itemERPCode,
    itemDescription,
    specification,
    productClass,
    requesterEmail,
    executiveChefEmail,
    HODDepartment,
  };

  //sample details group
  const sampleDetails = {
    supplierName: name,
    supplierEmail: email,
    ...rowRest,
  };

  //receiver details group
  const receiverDetails = {
    receiverErpId: erpId,
    receiverErpName: erpName,
  };

  //summary with group titles to automatically map through all detail groups
  const itemSummary = [
    { title: "Identifiers: ", data: ids },
    { title: "Item Details: ", data: itemDetails },
    { title: "Sample Details: ", data: sampleDetails },
    { title: "Receiver Details: ", data: receiverDetails },
  ];

  // sample images group
  const sampleImages = [
    { title: "Primary Product Image(s)", images: primaryProductImages },
    { title: "Secondary Product Image(s)", images: secondaryProductImages },
  ];

  //user approvals group
  const approvals = [
    { title: "Chef Approval", approval: userApproval },
    { title: "Executive Chef Approval", approval: execChefApproval },
    { title: "HOD Approval", approval: HODApproval },
  ];

  return (
    <Accordion
      sx={{
        mt: 2,
        width: "99%",
      }}
    >
      {/* accordion summary to display supplier name */}
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        aria-controls="panel1a-content"
        id="panel1a-header"
      >
        <Grid container>
          <Grid item xs={12}>
            <Typography>
              Supplier {index + 1}:{" "}
              {(decoded.role === "sampleControl" ||
                decoded.role === "sampleControlView" ||
                decoded.role === "procurement") &&
                sampleDetails.supplierName}{" "}
              Item Description: {itemDetails.itemDescription}
            </Typography>
          </Grid>
          <Grid item xs={12} sx={{ display: { md: "flex" } }} mt={1}></Grid>
        </Grid>
      </AccordionSummary>
      {/* accordion details with detail groups */}
      <AccordionDetails>
        {/* Item Summary */}
        {itemSummary.map((item, index) => {
          return (
            <DetailsDisplay
              title={item.title}
              data={item.data}
              gridProps={gridProperties}
              key={index}
            />
          );
        })}
        {/* Sample Images */}
        {sampleImages.map((item, index) => {
          return (
            item.images && (
              <Grid
                container
                style={{
                  marginBottom: "15px",
                }}
                key={index}
              >
                <Grid item xs={12} sm={5}>
                  <span>{item.title}</span>
                </Grid>
                <Grid item xs={12} sm={7}>
                  {primaryProductImages !== "pending" ? (
                    primaryProductImages.map((imageObject, index) => {
                      return (
                        <ViewImage key={index} productImage={imageObject} />
                      );
                    })
                  ) : (
                    <span>pending</span>
                  )}
                </Grid>
              </Grid>
            )
          );
        })}
        {/* Approval Details */}
        {approvals.map((item, index) => {
          return (
            item.approval !== undefined && (
              <DetailsDisplay
                data={item.approval}
                title={item.title}
                gridProps={gridProperties}
                key={index}
              />
            )
          );
        })}
      </AccordionDetails>
    </Accordion>
  );
}
